<template>
    <div>
        <Form :label-width="100" :model="formData" class="clearfix" ref="baseform">
            <Col span="24">
                <FormItem :label="$t('global.common.channel', { defaultValue: '渠道' })" >
                    <div>{{formData.accountFlag}}</div>
                </FormItem>
            </Col>
            <Col span="24">
                <FormItem label='SellerSKU' >
                    {{formData.sellerSku}}
                </FormItem>
            </Col>
            <Col span="24">
                <FormItem :label="$t('erp.product.product_type', { defaultValue: '产品类型' })" prop="type" :rules="required">
                    <Select v-model="formData.type" @on-change="changetable(formData.type)">
                        <Option value="single">{{$t('erp.channel.single_product', { defaultValue: '简单产品' })}}</Option>
                        <Option value="bundle">{{$t('erp.channel.bundle_product', { defaultValue: '组合产品' })}}</Option>
                    </Select>
                    <span class="color-error line-28">{{$t('erp.channel.bundle_product_attention', { defaultValue: '组合产品为一个Seller SKU对应多个ERP SKU的情况，虚拟产品可以不维护ERP SKU对应关系' })}}</span>
                </FormItem>
            </Col>
            <Col span="24">
                <FormItem label='ERPSKU' prop="erpSku" :rules="required" >
                    <erpSkuInput v-bind:value="formData.erpSku" @on-data="handleErpSku" @on-change="searcherpsku(formData.erpSku)"></erpSkuInput>
                    <span class="color-error">{{$t('erp.channel.attention_2', { defaultValue: '组合产品只能选择同一个项目的ERP SKU' })}}</span>
                </FormItem>
            </Col>
            <Col span="24" >
                <FormItem :label="$t('erp.product.product_line', { defaultValue: '项目' })">
                    {{formData.lineId | transferText('name',products)}}
                </FormItem>
            </Col>
            <Col span="24" v-if="showzuhe">
                <vTable
                :columns="columns" 
                :data="formList"
                size="small" 
                ref="table"  
                border 
                stripe></vTable>
            </Col>
        </Form>
        <div class="text-right margin-top-10">
            <vButton theme="primary" @click="submit">{{$t('global.common.save', { defaultValue: '保存' })}}</vButton>
            <vButton class="margin-left-10" @click="cancel">{{$t('global.common.cancel', { defaultValue: '取消' })}}</vButton>
        </div>
    </div>
</template>

<script>
import {
    HttpGetChannelOne,
    HttpSaveErpsku
} from '@/service/products/channel'
import {
	HttpGetProductsOne,
} from '@/service/products/allproducts'
import { HttpVsSkuList } from '@/service/boss/allot';
import erpSkuInput from '@components/templates/erpskuinput.vue';
import { mapState, mapGetters } from "vuex";
export default {
    props:['itemid'],
    components: {
		compFormEdit: () => import("@components/templates/formedit"),
        erpSkuInput
	},
    data(){
        return {
            loading1:false,
            formData:{},
            formList:[],
            erpSkusList:[],
            showzuhe:false,
            required: [{
                required: true,
                message: this.$t('global.common.required', { defaultValue: "该信息不能为空,请填写" })
            }],  
        }
    },
    created(){
        this.getDetail()
    },
    computed:{
        ...mapState('boss', ['products', 'accountTypes', 'accounts']),
        columns() {
            const _this = this;
            const showwidth = this.alltype == 'add'
            return [{
                title: 'ERPSKU',
                key: 'erpSku',
                render(h, { row }) {
                    return h('Input',{
                        props: {
                            size:'small',
                            value:row.erpSku,
                            readonly:true,
                        },
                        on: {
                            'input':(event) => {
                                row.erpSku = event
                                _this.formList[index] = row
                            }
                        },
                    })
                }
            }, {
                title: this.$t('fbb.accountmanage.amount', { defaultValue: '数量' }),
                key: 'qty',
                width:150,
                render(h, { row,index }) {
                    return h('InputNumber',{
                        props: {
                            size:'small',
                            min:1,
                            value:row.qty
                        },
                        on: {
                            'input': (event) => {
                                row.qty = event
                                // console.log(event)
                                _this.formList[index] = row
                            }
                        },
                    })
                }
            },  
            {
                title: this.$t('global.common.operation', { defaultValue: '操作' }),
                width: 80,
                render(h, { row,index }) {
                    return h('div', [
                        h('Button', {
                            props: {
                                type: "error",
                                size: 'small'
                            },
                            on: {
                                click: () => {
                                    _this.remove(index, row.id)
                                }
                            }
                        }, this.$t('global.common.delete', { defaultValue: '删除' }))
                    ])
                }
            },
            ]
        },
    },
    methods:{
        handleErpSku (row) {
            this.$set(this.formData, 'erpSku', row.erpSku);
            this.erpSkusList = [{
                name: row.erpSku,
                id: row.id,
                title: row.nameEn,
                lineId: row.lineId
            }];
        },
        getDetail(){
            HttpGetChannelOne({
				id:this.itemid
			}).then(res=>{
                this.formData = res.data;
                // console.log(res.data,'98989')
				this.handleData(res.data)
				
			},err=>{

			})
        },
        handleData(data){
            // console.log(data.erpSku)
            this.formList = data.productChannelRelateList
            if(data.type=='bundle'){
                this.showzuhe = true
                // 为组合产品就置空
                this.$set(this.formData,'erpSku','')
            }
        },
        changetable(type){
            if(type=='bundle'){
                this.showzuhe = true
            }else{
                this.showzuhe = false
            }
        },
        remoteMethod1(query){
            this.loading1 = true;
            HttpVsSkuList({page: 1,rows: 100,'search[CN_erpSku]':query}).then(res => {
                // console.log(res)
                this.loading1 = false;
                this.erpSkusList = res.data.content.map((item) => {
                    // console.log(item)
                    return { name: item.erpSku, id: item.id, title:item.nameEn, lineId:item.lineId }
                });
            });
        },
        searcherpsku(erpSku){
            if(erpSku){
                let productsItem = this.erpSkusList.filter(item=>{
                    return item.name == erpSku
                })
    
                // 项目填入
                this.formData.lineId = productsItem[0].lineId
                
                if(productsItem.length>0){
                    let obj = {
                        erpSku:productsItem[0].name,
                        qty:0,
                        productId:productsItem[0].id,
                        lineId:productsItem[0].lineId,
                    }
                    this.formList.push(obj)
                }
            }
        },
        clickblur(type){
            if(type==false){
                if(!this.formData.erpSku){
                    this.$refs.zierpselect.clearSingleSelect()
                }
            }
        },
        remove(index){
            // console.log(index)
            this.formList.splice(index,1);
            HttpGetProductsOne({id:this.formList[this.formList.length-1].productId}).then(res=>{

                this.formData.lineId = res.data.lineId
            })
        },
        submit(){
            // console.log(this.formList)
            // console.log(this.formData)
            let data = {
                orgId:global.SYSID,
                id:this.formData.id,
                lineId:this.formData.lineId,
                type:this.formData.type,
                erpSku:this.formData.erpSku,
                productChannelRelateList:this.formList
            }
            if(this.formData.erpSku==''){
                data.erpSku = this.formList[0].erpSku
            }
            // if (this.formData.type == 'bundle') {
            //     this.$VMessage.warning('组合产品类型下，可能会存在项目不一致的情况！')
            // }
            
            HttpSaveErpsku({
                ...data
            }).then(res=>{
                this.$VMessage.success(res.message)
                this.cancel()
                this.$emit('on-update')
            },err=>{
                
                this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
            })
        },
        cancel(){
            this.$emit('on-close')
        }
    }
}
</script>